const commentStartRegex = /^[ \t]*\/\*/;
const commentEndRegex = /\*\//;
const jsxPragmaRegex = /@jsx(?:Runtime)?\b/;

export const removeJsxRuntime = (sourceCode: string): string => {
	const lines = sourceCode.split('\n');
	const transformedLines: string[] = [];

	let index = 0;

	while (index < lines.length) {
		const line = lines[index];

		// Continue as long as we're not in a block comment
		if (!commentStartRegex.test(line)) {
			transformedLines.push(line);
			index++;
			continue;
		}

		const commentBlock = [line];
		index++;

		if (!commentEndRegex.test(line)) {
			// Find the end of the block comment
			while (index < lines.length && !commentEndRegex.test(lines[index])) {
				commentBlock.push(lines[index]);
				index++;
			}

			// Add the last line of the block comment
			if (index < lines.length) {
				commentBlock.push(lines[index]);
				index++;
			}
		}

		const commentText = commentBlock.join('\n');
		// If the comment text does not contain a JSX pragma, add the comment block to the transformed lines
		if (!jsxPragmaRegex.test(commentText)) {
			transformedLines.push(...commentBlock);
		}
	}

	return transformedLines.join('\n').trim();
};
